import { render, staticRenderFns } from "./AnxTextarea.vue?vue&type=template&id=38a20043&scoped=true&"
import script from "./AnxTextarea.vue?vue&type=script&lang=ts&"
export * from "./AnxTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./AnxTextarea.vue?vue&type=style&index=0&id=38a20043&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a20043",
  null
  
)

export default component.exports